import { styled } from '@mui/material'
import { MessageSender } from '@weblite/ts-action/message'
import { UserAvatar, WappAvatar } from '$common/avatar'
import { openUserProfile } from '$logic/router'
import { nothing } from '$func/utils'
import { AvatarSize } from '$common/avatar/avatar-base/types'

const Container = styled('div')`
  /* @noflip */
  margin: auto 12px 0 0;
`

export function ProfilePicture({ sender }: { sender: MessageSender }) {
  return (
    <Container>
      {sender.type === 'USER' ? (
        <UserAvatar
          userId={sender.id}
          size={AvatarSize.SM}
          onClick={e => {
            openUserProfile(sender.id)
            e.stopPropagation()
          }}
        />
      ) : sender.type === 'WAPP' ? (
        <WappAvatar wappId={sender.id} size={AvatarSize.SM} onClick={nothing} />
      ) : null}
    </Container>
  )
}
